/**
 * Where the browser thinks it is, captured once at signup.
 *
 * The user document had no location signal of any kind, which made "show me US users"
 * unanswerable for anyone who never typed a phone number. This records the two things the
 * browser will tell us for free.
 *
 * It stores the *raw* signals rather than a resolved country on purpose: the timezone ->
 * country mapping lives server-side in functions/src/shared/user-country.ts, so it can be
 * corrected or extended without shipping a frontend deploy and without the stored data
 * disagreeing with itself.
 *
 * Not a substitute for asking. It is a browser setting, so a VPN, a traveller, or a
 * deliberately-set clock will all read wrong — good enough to segment a leads list, not
 * good enough for anything that must be right.
 */
export function captureSignupLocale() {
  const locale = { capturedAt: new Date().toISOString() };

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) locale.timeZone = tz;
  } catch {
    // Intl is universal in our supported browsers, but a missing timezone is not worth
    // failing a signup over.
  }

  try {
    if (navigator.language) locale.language = navigator.language;
  } catch {
    // Same.
  }

  return locale;
}
